<div class="app-select-project-locations-dialog">
  <h2 mat-dialog-title class="text-center">
    Select project/location to clock into
  </h2>
  <mat-divider class="yellow-divider"></mat-divider>
  <mat-dialog-content>
    @if ((projectLocationsList$ | async); as projects) {
      <div>
        <label id="example-radio-group-label">Projects</label>
        <mat-radio-group
          aria-labelledby="example-radio-group-label"
          class="example-radio-group"
          >
          @for (project of projects; track project.projectID) {
            <div>
              <mat-card
                appearance="outlined"
                style="margin: 10px 0px"
                class="clickable"
                (click)="onHandleSelectProjectLocation(project)"
            [ngClass]="{
              selected: selectedProjectLocation.projectID === project.projectID
            }"
                >
                <mat-radio-button
                  class="example-radio-button"
                  [value]="project.projectID"
              [checked]="
                selectedProjectLocation.projectID === project.projectID
              "
                  >{{ project.name }}
                  @if (project.inRoster) {
                    <span class="in-roster">IN ROSTER</span>
                  }
                </mat-radio-button>
              </mat-card>
            </div>
          }
        </mat-radio-group>
      </div>
    } @else {
      <div class="no-projects" style="text-align: center">You have no projects!</div>
    }

    @if (webcamImage) {
      <div>
        <label>Preview photo</label>
        <img [src]="webcamImage" class="preview-selfie" />
      </div>
    }
  </mat-dialog-content>
  @if (selectedProjectLocation.projectID) {
    <mat-dialog-actions
      class="justify-center"
      >
      <button 
        mat-flat-button mat-dialog-close 
        (click)="onHandleSubmit()"
        [disabled]="selectedProjectLocation.project_selfie_enabled && !webcamImage"
        class="btn-blue">
        SUBMIT
      </button>
      <button
        mat-button
        mat-dialog-close
        class="btn-grey"
        (click)="data.loading$.next(false)"
        >
        CANCEL
      </button>
    </mat-dialog-actions>
  }
</div>
